
                  import { Viewer } from "@photo-sphere-viewer/core";
                  const loftViewer = new Viewer({
                    container: document.querySelector("#loft"),
                    panorama: '/images/VT/Loft.jpg',
                    caption:'The Loft',
                    navbar:['zoom', 'move','caption'], 
                  });
                